import { useState, useEffect } from 'react';
import { Button, Modal, Input, message } from 'antd';
import ActionsMenu from '../../../ActionsMenu';
import { isSupportAgent2, isSupportAgent3, isSupportLead, isSupportManager } from '../../../../helpers/genericHelper';
import FileBankruptcy from '../Actions/FileBankruptcy';
import API from '../../../../services/API';

export default function ProfileActions({
  data,
  userId,
  userBlockStatus,
  reloadData,
  userBlockLoadingStatus,
  openEditAccountModal,
  forceLogout,
  saveAndBuildCredit,
  furnishingEvents,
  accountActions = [],
  paymentActions = [],
  creditReportActions = [],
  riskActions = []
}) {

  const {
    isUserBankrupt,
    silaUserStatus,
    avaUserStatus
  } = userBlockStatus || {};

  const [block, setblock] = useState(null);
  const [blockReason, setblockReason] = useState(null);
  const [bloclModalVisible, setBlockModalVisible] = useState(false);
  const [userBlocked, setUserBlocked] = useState("");

  useEffect(() => {
    setUserBlocked(data.blockStatus === "BLOCKED");
  }, [data.blockStatus]);


  const blockHandler = (event) => {
    setblock(event);
    setBlockModalVisible(true);
  };

  const blockConfirmed = async () => {
    if (block === "block") {
      try {
        await API.blockUser(userId, blockReason);
        message.success("Successfully blocked account");
        setUserBlocked(true);
      } catch (error) {
        message.error("Unable to block account");
      } finally {
        setBlockModalVisible(false);
        reloadData();
      }
    } else if (block === "unblock") {
      try {
        await API.unBlockUser(userId, blockReason);
        message.success("Successfully unblocked account");
        setUserBlocked(false);
      } catch (error) {
        message.error("Unable to unblock account");
      } finally {
        setBlockModalVisible(false);
        reloadData();
      }
    }
  };

  const closeBlockModal = () => {
    setblockReason(null);
    setBlockModalVisible(false);
  };

  const groups = [
    {
      title: 'Account',
      items: [
        isSupportAgent2() && <Button key="edit" onClick={openEditAccountModal}>Edit Account</Button>,
        ...accountActions
      ]
    },
    { title: 'Payments', items: paymentActions },
    { title: 'Credit Report', items: creditReportActions },
    {
      title: 'Risk and SSN',
      items: [
        ...riskActions,
        isSupportLead() && (avaUserStatus?.isBlocked
          ? <Button key="unblock" danger loading={userBlockLoadingStatus} disabled={isUserBankrupt} onClick={() => blockHandler("unblock")}>Unblock</Button>
          : <Button key="block" danger loading={userBlockLoadingStatus} disabled={isUserBankrupt} onClick={() => blockHandler("block")}>Block</Button>)
      ]
    },
    {
      title: 'Danger Zone',
      danger: true,
      items: [
        isSupportManager() && <Button
          key="logout"
          danger
          loading={userBlockLoadingStatus}
          onClick={() => window.confirm("Are you sure you want to force logout this user?") && forceLogout()}>
          Force Logout
        </Button>,
        isSupportAgent3() && <FileBankruptcy
          key="bankruptcy"
          furnishingEvents={furnishingEvents}
          userId={userId} saveAndBuildCredit={saveAndBuildCredit}
          isBankruptStatus={isUserBankrupt}
          onStatusChange={reloadData}
          data={data}/>
      ]
    }
  ];

  return (
    <>
      <ActionsMenu groups={groups} />
      <Modal
        title={"Confirmation"}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        okButtonProps={{
          disabled: !blockReason,
        }}
        closable={true}
        visible={bloclModalVisible}
        onOk={blockConfirmed}
        onCancel={closeBlockModal}
        className="confirm-modal"
      >
        <p>Please provide the reason?</p>
        <Input
          onChange={(e) => setblockReason(e.target.value)}
          placeholder={"Reason..."}
          value={blockReason}
        />
      </Modal>
    </>
  )
}
